import { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Stack,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Switch,
  Autocomplete,
  TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  fetchServieCenterList,
  fetchEngineerList,
  fetchEngineerWiseList,
  fetchRegionList,
  fetchServiceCenterList,
} from "../../../API Service/apiService";

import { tableCellClasses } from "@mui/material/TableCell";

import { useNavigate } from "react-router-dom";
import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";

import DynamicTabs from "../../../components/DynamicTabs";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../../Componants/Common/Loader";
import Paginate from "../../../Componants/Common/Paginate";

const ProSpan = styled("span")({
  display: "inline-block",
  height: "1em",
  width: "1em",
  verticalAlign: "middle",
  marginLeft: "0.3em",
  marginBottom: "0.08em",
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundImage: "url(https://mui.com/static/x/pro.svg)",
});

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme?.palette?.common?.blue || "#33499F",
    color: theme?.palette?.common?.white || "#fff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme?.palette?.action?.hover || "#f5f5f5",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const noBorderStyle = {
  border: "none",
};

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor:
          theme?.palette?.mode === "dark" ? "#177ddc" : "#1890ff",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition:
      theme?.transitions?.create?.(["width"], {
        duration: 200,
      }) || "none",
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme?.palette?.mode === "dark"
        ? "rgba(255,255,255,.35)"
        : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));
const rows = [
  createData("Frozen yoghurt", 159, 6.0, 24),
  createData("Ice cream sandwich", 237, 9.0, 37),
  createData("Eclair", 262, 16.0, 24),
  createData("Cupcake", 305, 3.7, 67),
  createData("Gingerbread", 356, 16.0, 49),
];

const tableData = [createData("200", "12")];
const jobsheet = [{ label: "Repair" }, { label: "Replacement" }];
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme?.palette?.mode === "" ? "#1A2027" : "#fff",
  ...theme?.typography?.body2,
  padding: theme?.spacing?.(1) || "8px",
  color: theme?.palette?.text?.secondary || "#666",
  marginLeft: `${theme?.spacing?.(1.25) || "10px"} !important`,
  marginRight: `${theme?.spacing?.(1.25) || "10px"} !important`,
  fontWeight: 700,
}));

const Dashboard = () => {
  const navigate = useNavigate();
  const [centerName, setCenterName] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [serviceCenterList, setServiceCenterList] = useState([]);
  const [engineerList, setEngineerList] = useState([]);
  const [engineerTableData, setEngineerTableData] = useState([]);
  const [regionTableData, setRegionTableData] = useState([]);
  const [serviceTableData, setServiceTableData] = useState([]);
  const [statusTableData, setStatusTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [organizationID, setOrganizationID] = useState("");
  const [page, setPage] = useState(1);
  const [dataSize, setDataSize] = useState(10);
  const [pagination, setPagination] = useState({
    region: {
      page: 1,
      limit: 10,
      totalRecords: 0,
    },
    service: {
      page: 1,
      limit: 10,
      totalRecords: 0,
    },
    engineer: {
      page: 1,
      limit: 10,
      totalRecords: 0,
    },
  });

  const [searchParams, setSearchParams] = useState({
    serviceCenterId: "",
    engineerId: "",
  });

  const getServiceCenterList = async () => {
    try {
      setLoading(true);
      const response = await fetchServieCenterList(organizationID);
      if (response.status === "success") {
        setServiceCenterList(response.data.serviceCenters);
      }
    } catch (error) {
      console.log(`Error in fetching service center list`, error);
    } finally {
      setLoading(false);
    }
  };

  const getEngineerList = async (serviceCenterId) => {
    try {
      let params = {
        forAssignEngineer: false,
        serviceCenterId,
      }
      setLoading(true);
      const response = await fetchEngineerList(params);
      if (response.status === "success") {
        console.log("response.data.engineers", response.data.engineers)
        setEngineerList(response.data.engineers);
      }
    } catch (error) {
      console.log(`Error in fetching engineer list`, error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getServiceCenterList();
  }, []);

  const handleInvetorySearch = async () => {
    try {
      setLoading(true);
      await fetchEngineerInvetoryList(searchParams);
    } catch (err) {
      console.log(`Error fetching engineer wise inventory ${err}`);
      toast.error("Failed to fetch engineer inventory data");
    } finally {
      setLoading(false);
    }
  };

  // api call for Engineer wise inventory
  const fetchEngineerInvetoryList = async (params = searchParams) => {
    try {
      setLoading(true);
      const response = await fetchEngineerWiseList({
        ...params,
        page: pagination.engineer.page,
        limit: pagination.engineer.limit,
      });
      if (response.status === 200) {
        setEngineerTableData(response.data.data.engineers);
        setPagination((prev) => ({
          ...prev,
          engineer: {
            ...prev.engineer,
            totalRecords: response.data.data.pagination.totalItems,
          },
        }));
      } else {
        setEngineerTableData([]);
        toast.error(response.message);
      }
    } catch (err) {
      console.log(`Error fetching engineer wise inventory ${err}`);
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  // region wise list
  const getRegionList = async (params = searchParams) => {
    try {
      setLoading(true);
      const response = await fetchRegionList({
        ...params,
        page: pagination.region.page,
        limit: pagination.region.limit,
      });
      if (response.status === 200) {
        setRegionTableData(response.data.data.zones);
        setPagination((prev) => ({
          ...prev,
          region: {
            ...prev.region,
            totalRecords: response.data.data.pagination.totalItems || 0,
          },
        }));
      } else {
        setRegionTableData([]);
        toast.error(response.message);
      }
    } catch (err) {
      console.log("Error fetching region wise list", err);
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  // service center wise list
  const getServiceList = async (params = searchParams) => {
    try {
      setLoading(true);
      const response = await fetchServiceCenterList({
        ...params,
        page: pagination.service.page,
        limit: pagination.service.limit,
      });
      if (response.status === 200) {
        setServiceTableData(response.data.data.serviceCenters);
        setPagination((prev) => ({
          ...prev,
          service: {
            ...prev.service,
            totalRecords:
              response.data.data.pagination?.totalRecords ||
              response.data.data.pagination?.totalItems ||
              0,
          },
        }));
      } else {
        setServiceTableData([]);
        toast.error(response.message);
      }
    } catch (err) {
      console.log("Error fetching service center list", err);
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRegionList();
    getServiceList();
    // Only fetch engineer inventory if no search params are set
    if (!searchParams.serviceCenterId && !searchParams.engineerId) {
      fetchEngineerInvetoryList();
    }
  }, []);

  useEffect(() => {
    // Reset pagination when search params change
    setPagination(prev => ({
      ...prev,
      engineer: {
        ...prev.engineer,
        page: 1
      }
    }));
  }, [searchParams]);

  const handlePageChange = async (newPage, listType) => {
    if (newPage < 1) return;
    const maxPage = Math.ceil(
      pagination[listType].totalRecords / pagination[listType].limit
    );
    if (newPage > maxPage) return;

    setPagination((prev) => ({
      ...prev,
      [listType]: {
        ...prev[listType],
        page: newPage,
      },
    }));

    // Get the appropriate fetch function based on list type
    const fetchFunctions = {
      region: getRegionList,
      service: getServiceList,
      engineer: fetchEngineerInvetoryList,
    };

    try {
      setLoading(true);
      await fetchFunctions[listType]();
    } catch (error) {
      console.error(`Error updating ${listType} data:`, error);
      toast.error(`Failed to fetch ${listType} data`);
    } finally {
      setLoading(false);
    }
  };
  // Add console logs to debug pagination
  useEffect(() => {
    console.log("Current Pagination State:", pagination);
  }, [pagination]);

  return (
    <>
      <Grid container>
        {loading && <Loader />}
        <Toaster />
        <HeaderNavigation value={"Inventory Dashboard"} />
        <Grid container sx={{ width: "100%" }}></Grid>
        <DynamicTabs />

        {/* --------------box2--------------- */}

        <Grid
          container
          spacing={2}
          sx={{
            background: "",
            marginLeft: "10px",
            marginTop: "4px",
            marginRight: "10px",
            fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
            width: "100%",
            borderRadius: "5px",
            padding: "10px",
            fontWeight: 600,
          }}
        >
          <Grid item sm={12} md={12}>
            <Box>HO Warehouse</Box>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="space-evenly"
            alignItems="flex-start"
          >
            {statusTableData.map((row) => (
              <Grid
                key={row.statusTypeID}
                item
                xs={12}
                sm={6}
                md={4}
                sx={{
                  padding: " 5px 50px",
                  height: "auto",
                  justifyContent: "center",
                }}
              >
                <TableContainer component={Paper} sx={{ borderRadius: "12px" }}>
                  <Table aria-label="customized table">
                    <TableHead sx={{ background: "#33499F" }}>
                      <TableRow sx={{ justifyContent: "center" }}>
                        <StyledTableCell
                          align="center"
                          colSpan={2}
                          sx={{
                            background: "#33499F",
                            ...noBorderStyle,
                            padding: "0",
                          }}
                        >
                          {/* {row.statusType} */}
                        </StyledTableCell>
                      </TableRow>
                      <TableRow>
                        <StyledTableCell
                          sx={{ ...noBorderStyle, padding: "0 30px" }}
                        >
                          QTY
                        </StyledTableCell>
                        <StyledTableCell
                          sx={{ ...noBorderStyle, padding: "7px 30px" }}
                          align="right"
                        >
                          Value
                        </StyledTableCell>
                      </TableRow>
                      <TableRow>
                        <StyledTableCell
                          sx={{ ...noBorderStyle, padding: "0 30px" }}
                        >
                          {/* {row.quantity} */}
                        </StyledTableCell>
                        <StyledTableCell
                          sx={{ ...noBorderStyle, padding: "7px 30px" }}
                          align="right"
                        >
                          {/* {row.value} */}
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                  </Table>
                </TableContainer>
              </Grid>
            ))}
          </Grid>
        </Grid>

        {/* --------------box3--------------- */}

        <Grid
          container
          spacing={2}
          sx={{
            background: "",
            margin: " 4px 10px 4px 1px",
            // marginTop: "4px",
            // marginRight: "10px",
            fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
            width: "100%",
            borderRadius: "5px",
            padding: "10px",
            fontWeight: 600,
          }}
        >
          {/* region Wise */}
          <Grid item sm={12} md={6}>
            <Stack>
              <Grid sx={{ padding: "7px" }}>
                <Box>State Wise</Box>
              </Grid>
            </Stack>
            <TableContainer
              component={Paper}
              sx={{
                height: "440px", // Height for 10 rows + header
                overflowY: "auto",
              }}
            >
              <Table sx={{ minWidth: 0 }} aria-label="customized table">
                <TableHead sx={{ background: "#33499F" }}>
                  <TableRow>
                    <StyledTableCell>State</StyledTableCell>
                    <StyledTableCell align="right">Total</StyledTableCell>
                    <StyledTableCell align="right">Good</StyledTableCell>
                    <StyledTableCell align="right">Defective</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {regionTableData.map((row) => (
                    <StyledTableRow key={row.stateId}>
                      <StyledTableCell scope="row">
                        {row.zoneName}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {row.totalQuantity}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {row.goodQuantity}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {row.defectiveQuantity}
                      </StyledTableCell>
                      {/* <StyledTableCell align="right">
                        {row.protein}
                      </StyledTableCell> */}
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <div className="pagination-container" style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              marginTop: '1rem'
            }}>
              <Paginate
                page={pagination.region.page}
                totalRecords={pagination.region.totalRecords}
                onPageChange={(newPage) => handlePageChange(newPage, "region")}
                dataSize={pagination.region.limit}
              />
            </div>
          </Grid>
          {/* service wise */}
          <Grid item sm={12} md={6} sx={{ marginTop: "14px" }}>
            {/* <Stack> */}

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                maring: "auto",
              }}
            >
              <span>Service Centre Wise</span>

              {/* <FormGroup>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography>Quantity</Typography>
                  <AntSwitch
                    checked={isChecked}
                    // onClick={handleToggleChange}
                    inputProps={{ "aria-label": "ant design" }}
                  />
                  <Typography>
                    {console.log(`i am isChecked ${isChecked}`)}
                    Value
                  </Typography>
                </Stack>
              </FormGroup> */}
            </Box>
            <TableContainer
              component={Paper}
              sx={{
                height: "440px", // Height for 10 rows + header
                overflowY: "auto",
              }}
            >
              <Table sx={{ minWidth: 0 }} aria-label="customized table">
                <TableHead sx={{ background: "#33499F" }}>
                  <TableRow>
                    <StyledTableCell>ASC</StyledTableCell>
                    <StyledTableCell align="right">Total</StyledTableCell>
                    <StyledTableCell align="right">Good</StyledTableCell>
                    <StyledTableCell align="right">Defective</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {serviceTableData.map((row) => (
                    <StyledTableRow key={row.serviceCenterId}>
                      <StyledTableCell scope="row">
                        {row.serviceCenterName}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {row.totalQuantity}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {row.goodQuantity}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {row.defectiveQuantity}
                      </StyledTableCell>
                      {/* <StyledTableCell align="right">
                        {row.protein}
                      </StyledTableCell> */}
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <div className="pagination-container" style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              marginTop: '1rem'
            }}>
              <Paginate
                page={pagination.service.page}
                totalRecords={pagination.service.totalRecords}
                onPageChange={(newPage) => handlePageChange(newPage, "service")}
                dataSize={pagination.service.limit}
              />
            </div>
          </Grid>
        </Grid>

        {/* --------------Box4--------------- */}
        <Grid
          container
          spacing={2}
          sx={{
            background: "",
            margin: " 4px 10px 4px 1px",
            // marginTop: "4px",
            // marginRight: "10px",
            fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
            width: "100%",
            borderRadius: "5px",
            padding: "10px",
            fontWeight: 600,
          }}
        >
          {/*  */}

          <Grid
            container
            sx={{
              background: "",
              margin: " 4px 10px 4px 1px",
              // marginTop: "4px",
              // marginRight: "10px",
              fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
              width: "100%",
              borderRadius: "5px",
              padding: "10px",
              fontWeight: 600,
            }}
          >
            <Grid item sm={12} md={12}>
              <Box>Engineer Wise Inventory</Box>
            </Grid>

            <Grid container gap={2}>
              <Grid item md={3}>
                <Autocomplete
                  options={serviceCenterList}
                  getOptionLabel={(option) => option.serviceCenter || ""}
                  value={
                    serviceCenterList.find(
                      (item) => item._id === searchParams.serviceCenterId
                    ) || null
                  }
                  onChange={(e, val) => {
                    setSearchParams((prev) => ({
                      ...prev,
                      serviceCenterId: val ? val._id : "",
                    }));
                    if (val) {
                      getEngineerList(val._id);
                    } else {
                      setEngineerList([]);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Service Center"
                      variant="standard"
                      style={{ width: "12.5rem" }}
                    />
                  )}
                />
              </Grid>
              <Grid item md={3}>
                <Autocomplete
                  options={engineerList}
                  getOptionLabel={(option) => option.name || ""}
                  value={
                    engineerList.find(
                      (engineer) => engineer._id === searchParams.engineerId
                    ) || null
                  }
                  onChange={(e, val) => {
                    setSearchParams((prev) => ({
                      ...prev,
                      engineerId: val ? val._id : "",
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Engineer"
                      variant="standard"
                      style={{ width: "12.5rem" }}
                    />
                  )}
                />
              </Grid>

              <Grid item md={4} sx={{ display: 'flex', gap: 1 }}>
                <Button
                  variant="contained"
                  size="medium"
                  onClick={handleInvetorySearch}
                  sx={{
                    width: "10rem",
                    margin: "5px",
                    background: "green",
                    "&:focus": {
                      outline: "none",
                      backgroundColor: "green",
                      boxShadow: "none",
                    },
                    ".MuiButton-root:active": {
                      outline: "none !important",
                      boxShadow: "none !important",
                      backgroundColor: "#3c52b2 !important",
                    },
                    "&:hover": {
                      backgroundColor: "green",
                      boxShadow: "none",
                    },
                  }}
                >
                  Search
                </Button>
                <Button
                  variant="contained"
                  size="medium"
                  onClick={() => {
                    // Clear search params
                    setSearchParams({
                      serviceCenterId: "",
                      engineerId: "",
                    });
                    // Clear engineer list
                    setEngineerList([]);
                    // Reset pagination
                    setPagination(prev => ({
                      ...prev,
                      engineer: {
                        ...prev.engineer,
                        page: 1
                      }
                    }));
                    // Clear any validation states if they exist
                    const serviceCenterField = document.querySelector('input[id*="service-center"]');
                    const engineerField = document.querySelector('input[id*="engineer"]');
                    if (serviceCenterField) serviceCenterField.value = '';
                    if (engineerField) engineerField.value = '';
                    // Fetch fresh data
                    fetchEngineerInvetoryList({
                      serviceCenterId: "",
                      engineerId: "",
                    });
                  }}
                  sx={{
                    width: "10rem",
                    margin: "5px",
                    background: "#d32f2f",
                    "&:focus": {
                      outline: "none",
                      backgroundColor: "#d32f2f",
                      boxShadow: "none",
                    },
                    ".MuiButton-root:active": {
                      outline: "none !important",
                      boxShadow: "none !important",
                    },
                    "&:hover": {
                      backgroundColor: "#c62828",
                      boxShadow: "none",
                    },
                  }}
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item sm={12} md={6}>
            <TableContainer
              component={Paper}
              sx={{
                height: "440px", // Height for 10 rows + header
                overflowY: "auto",
              }}
            >
              <Table sx={{ minWidth: 0 }} aria-label="customized table">
                <TableHead sx={{ background: "#33499F" }}>
                  <TableRow>
                    <StyledTableCell>Engineer</StyledTableCell>
                    <StyledTableCell align="right">Total</StyledTableCell>
                    <StyledTableCell align="right">Good</StyledTableCell>
                    <StyledTableCell align="right">Defective</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {engineerTableData.length > 0 ? (
                    engineerTableData.map((row) => (
                      <StyledTableRow key={row.engineerId}>
                        <StyledTableCell scope="row">
                          {row.engineerName}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {row.totalStock}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {row.goodStock}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {row.defectiveStock}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell colSpan={4} align="center" sx={{ py: 3 }}>
                        No Data Available
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <div className="pagination-container" style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              marginTop: '1rem'
            }}>
              <Paginate
                page={pagination.engineer.page}
                totalRecords={pagination.engineer.totalRecords}
                onPageChange={(newPage) =>
                  handlePageChange(newPage, "engineer")
                }
                dataSize={pagination.engineer.limit}
              />
            </div>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Dashboard;
